export const AllSarConst = {
    apiName: 'api/AllSAR',
    getAllRequests: '/GetAllRequests',
    getAllRequestsForExport: '/GetAllRequestForExport',
    FILENAME: 'AllRequests'
};